/* Constants */
import { NOT_FOUND_PATHS_OF_CATEGORY } from '@/constants/notFoundPathsOfCategory'

export default defineNuxtRouteMiddleware(({ path }) => {
  const notFoundPagePaths = Object.keys(NOT_FOUND_PATHS_OF_CATEGORY)

  for (const notFoundPagePath of notFoundPagePaths) {
    if (notFoundPagePath === path) {
      return navigateTo(
        {
          path: NOT_FOUND_PATHS_OF_CATEGORY[
            notFoundPagePath as keyof typeof NOT_FOUND_PATHS_OF_CATEGORY
          ],
        },
        {
          redirectCode: 301,
        },
      )
    }
  }
})
